import "./PlayEditToggle.css"

export enum PlayEdit {
  Play,
  Edit,
}

export type PlayEditToggleProps = {
  playEdit: PlayEdit;
  onChange: (playEdit : PlayEdit) => void;
}

export function PlayEditToggle({playEdit, onChange} : PlayEditToggleProps) {
  const nextValue = (playEdit + 1) % (Object.keys(PlayEdit).length / 2);

  return (
    <button className="PlayEditToggle" onClick={() => onChange(nextValue)}>
      {PlayEdit[nextValue]}
    </button>
  );
}

export default PlayEditToggle;